export default __webpack_public_path__ + "static/media/photo--sm--133.9eab7463.jpg";